import { ProductSlug } from 'common/billing'
import { PricePeriod } from 'common/billing/constants/PricePeriod'
import { ProInfoProductV3 } from 'common/billing/entities/pro/interfaces'
import { getActiveProduct } from 'common/billing/entities/pro/selectors'
import { ProductType } from 'common/core/interfaces/products'
import { getCurrentAccount, getIsAccountFlagEnabled } from 'common/core/selectors/appSelectors'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'

export const ACTIVE_USERS_AMOUNT_THRESHOLD = 80

const PRODUCTS_DATA = {
  [ProductType.INBOX]: null,
  [ProductType.AUTOMATION]: null,

  [ProductType.ESSENTIAL]: {
    totalSaves: 36,
    monthlyPrice: 17,
    annualPrice: 14,
    totalMonhlyPrice: 204,
    totalAnnualPrice: 168,
    annualProductSlug: ProductSlug.ESSENTIAL_YEARLY,
  },
  [ProductType.PRO]: {
    totalSaves: 84,
    monthlyPrice: 39,
    annualPrice: 29,
    totalMonhlyPrice: 468,
    totalAnnualPrice: 348,
    annualProductSlug: ProductSlug.PRO_YEARLY,
  },
  [ProductType.BUSINESS]: {
    totalSaves: 360,
    monthlyPrice: 99,
    annualPrice: 69,
    totalMonhlyPrice: 1188,
    totalAnnualPrice: 828,
    annualProductSlug: ProductSlug.BUSINESS_YEARLY,
  },
  [ProductType.ADVANCED]: {
    totalSaves: 720,
    monthlyPrice: 199,
    annualPrice: 139,
    totalMonhlyPrice: 2388,
    totalAnnualPrice: 1668,
    annualProductSlug: ProductSlug.ADVANCED_YEARLY,
  },
}

export const getAnnualExpansionActiveUsers = (state: RootState) =>
  getCurrentAccount(state).annual_expansion_active_users ?? 0

export const getIsAnnualExpansionExperimentEnabled = (state: RootState) =>
  getIsAccountFlagEnabled(state, AccountFlag.ENABLE_ANNUAL_EXPANSION) &&
  getAnnualExpansionActiveUsers(state) >= ACTIVE_USERS_AMOUNT_THRESHOLD

export const getAnnualExpansionData = (state: RootState, type?: ProductType) => {
  const productType = type || getActiveProduct(state)?.type

  return productType ? PRODUCTS_DATA[productType] : null
}

export const getIsActiveProductMonthly = (state: RootState) =>
  (getActiveProduct(state) as Nullable<ProInfoProductV3>)?.duration === PricePeriod.MONTHLY

export const getIsAnnualExpansionNotificationEligible = (state: RootState) =>
  getAnnualExpansionActiveUsers(state) >= ACTIVE_USERS_AMOUNT_THRESHOLD &&
  Boolean(getAnnualExpansionData(state)) &&
  getIsActiveProductMonthly(state)

export const getIsAnnualExpansionNotificationAvailable = (state: RootState) =>
  getIsAnnualExpansionNotificationEligible(state) &&
  getIsAccountFlagEnabled(state, AccountFlag.ENABLE_ANNUAL_EXPANSION)
